import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, input, signal } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseInputComponent } from '../common/base-input.component';
import { LepiIcon } from '@lepisode-ui/components';
import { LabelComponent } from '../label/label.component';

@Component({
  selector: 'app-input-password',
  standalone: true,
  imports: [CommonModule, FormsModule, LepiIcon, LabelComponent],
  templateUrl: './input-password.component.html',
  styleUrl: '../common/input.common.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InputPasswordComponent,
      multi: true,
    },
  ],
})
export class InputPasswordComponent
  extends BaseInputComponent
  implements AfterViewInit
{
  min = input<number>(4);
  customCss = input<string>('text-sm text-gray-800');
}
